module.exports = __webpack_public_path__ + "static/media/WorkLBusinessLogo.b56d0a88.png";